/**
 * Paragraph will either render a plain paragraph with black text OR a specially styled
 * "excerpt" with larger eggplant coloured text.
 *
 * If the Paragraph is only one line and matches `@excerpt <text>` then we will apply
 * the custom styling.
 *
 * Example:
 *
 * @excerpt This is an excerpt

 *   -- vs. --

 * @excer this is **not** going to be rendered as an excerpt because it doesn't match
 */
import {ReactMarkdownProps} from 'react-markdown/lib/ast-to-react';

import {Text} from '#component/base';
import {TextProps} from '#component/base/Text';

// The Paragraph prop types are super confusing. ReactMarkdownProps seems to fullfil it though
export const Paragraph = ({
  children,
  node,
  excerptProps,
  ...otherProps
}: Omit<ReactMarkdownProps, 'color'> & TextProps<'p'> & {excerptProps?: TextProps<'p'>}) => {
  // If there is only one child, which has type `text` we will check to see if it starts with
  // `@excerpt<space>`, and if it does we will apply custom excerpt styling to it.
  if (node.children.length === 1 && node.children[0].type === 'text') {
    const match = node.children[0].value.match(/(^\@excerpt\s)?(.+)/);

    // The string starts with the special `@excerpt` tag so render it as such...
    if (match?.[1]) {
      return (
        <Text as="p" color="eggplantDark" {...excerptProps}>
          {match[2]}
        </Text>
      );
    }
  }

  //... otherwise render a normal paragraph
  return (
    <Text as="p" color="mineShaft" {...otherProps}>
      {children}
    </Text>
  );
};
